import { Stat } from '@chakra-ui/react';
import { InfoTip } from '@components/ui/toggle-tip';

interface Props {
  label: string;
  value: string;
  tooltipContent?: string;
}
const StatCard = ({ label, value, tooltipContent }: Props) => {
  return (
    <Stat.Root bg="surface.muted" borderRadius="lg" p={3}>
      <Stat.Label fontSize="sm">
        {label}
        <InfoTip>{tooltipContent}</InfoTip>
      </Stat.Label>
      <Stat.ValueText fontSize="md" fontWeight="medium">
        {value}
      </Stat.ValueText>
    </Stat.Root>
  );
};

export default StatCard;
